var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0999,
    cy: 18.7,
    r: 18.7,
    fill: "#EDEEFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3809 30.6052C26.8202 30.6052 31.0048 26.4206 31.0048 18.9813C31.0048 11.542 26.8202 7.35742 19.3809 7.35742C11.9416 7.35742 7.75696 11.542 7.75696 18.9813C7.75696 26.4206 11.9416 30.6052 19.3809 30.6052Z",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5685 22.1263C17.4835 21.5898 21.2774 21.5898 25.1924 22.1263",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.824 15.5853V16.8371",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9377 15.5853V16.8371",
    stroke: "#4A56DC",
    strokeWidth: 1.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile3);
export default __webpack_public_path__ + "static/media/smile-3.1505eed51745bbcc4e2a8ca13bfefada.svg";
export { ForwardRef as ReactComponent };